<template>
    <div class="myPage92">
        <div class="myContent m_mar0a m_width">
            <div class="myFlexBox m_flex m_ais m_jcsb">
                <div class="itemBox" v-for="(group, groupIndex) in navGroups" :key="groupIndex">
                    <div class="title">{{ group.groupTitle }}</div>
                    <div class="text btnHoverLine" v-for="(item, index) in group.list" :key="index" @click="goFooterNav(item)">
                        {{ item.title }}
                    </div>
                </div>
                <div class="itemBox">
                    <div class="title">社交媒体</div>
                    <div class="iconBox m_flex m_ais m_jcs m_wrap">
                        <img src="@/assets/images/wx.png" class="icon" alt="" @click="openSocial(settings.wechat_url)" />
                        <img src="@/assets/images/bilbli.png" class="icon" alt="" @click="openSocial(settings.bilibili_url)" />
                    </div>
                </div>
                <div class="greyLine"></div>
                <div class="introBox">
                    <div class="title">{{ settings.brand_title }}</div>
                    <div class="title2">{{ settings.brand_slogan }}</div>
                    <div class="text">
                        {{ settings.brand_intro }}
                    </div>
                    <div class="title2">全国免费热线：</div>
                    <div class="text">{{ settings.hotline }}</div>
                    <div class="title2">联系电话:</div>
                    <div class="text">{{ settings.phone }}</div>
                    <div class="title2">邮箱:</div>
                    <div class="text">{{ settings.email }}</div>
                </div>
            </div>

            <div class="hGreyLine"></div>
            <div class="logoLineBox m_flex m_aic m_jcs">
                <img src="@/assets/images/logo.png" class="bottomLogo" alt="" />
                <div class="myText btnHoverLine" v-for="(item, index) in brandList" :key="index" @click="goBrandDetail(item)">{{ item.title }}</div>
            </div>
            <div class="hGreyLine"></div>
            <div class="bottomText1">{{ settings.copyright }}</div>
            <div class="bottomTextFlex m_flex m_aic m_jcs">
                <div class="bottomText2">{{ settings.copy_notice }}</div>
                <div class="redText btnHoverLine" v-if="settings.icp">{{ settings.icp }}</div>
                <div class="redText btnHoverLine" v-for="(item, index) in footerLinks" :key="index" @click="goPageLink(item)">{{ item.title }}</div>
                <!-- <div class="redText btnHoverLine">网站地图</div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            navGroups: [],
            settings: {
                brand_title: '弗顿',
                brand_slogan: '专注、真诚、创新、共赢',
                brand_intro: '弗顿科学以“中国新纯度”为使命，致力于打造国际一流的高纯溶剂品牌。通过“进口替代、新型销售、生物科技”的发展战略，公司不断完善高纯生化产品研发体系，建立新型销售渠道与合作模式，积极推动生物制药技术的创新与发展。',
                hotline: '4009963683',
                phone: '027-65522680',
                email: 'Sales@ftsci.com.cn',
                copyright: '©2025年版权归湖北弗顿科学技术有限公司所有。版权所有。',
                copy_notice: '未经许可，严禁复制本网站上的任何资料。',
                icp: '鄂ICP备20009437号-1',
                wechat_url: '',
                bilibili_url: '',
            },
            brandList: [],
            footerLinks: [],
        }
    },
    async created() {
        this.setDefaultFooter()
        this.getFooter()
    },
    mounted() {},
    methods: {
        setDefaultFooter() {
            this.navGroups = [
                {
                    groupTitle: '支持',
                    list: [
                        { title: '常见问题', linkType: 'article', linkValue: 'faq' },
                        { title: '订购指南', linkType: 'article', linkValue: 'ordering-information' },
                        { title: '售后服务', linkType: 'article', linkValue: 'after-sales' },
                    ],
                },
                {
                    groupTitle: '订单',
                    list: [
                        { title: '快速下单', linkType: 'path', linkValue: '/quick-order' },
                        { title: '定制服务', linkType: 'path', linkValue: '/services/product-services' },
                    ],
                },
                {
                    groupTitle: '公司',
                    list: [
                        { title: '关于我们', linkType: 'path', linkValue: '/about' },
                        { title: '责任', linkType: 'path', linkValue: '/life-science' },
                        { title: '活动', linkType: 'path', linkValue: '/events' },
                        { title: '新闻稿', linkType: 'path', linkValue: '/news' },
                        { title: '招聘', linkType: 'page', linkValue: 'careers' },
                    ],
                },
            ]
            this.footerLinks = [
                { pageKey: 'personal-info-consent', title: '个人信息收集同意书' },
                { pageKey: 'privacy', title: '隐私声明' },
                { pageKey: 'terms', title: '网站使用条款' },
                { pageKey: 'sales-terms', title: '销售通用条款与条件' },
                { pageKey: 'danger-license', title: '危险化学品经营许可证' },
            ]
        },
        goBrandDetail(item) {
            this.$router.push({
                path: '/brand',
                query: {
                    id: item.id,
                },
            })
        },
        async getFooter() {
            let res = await this.api_website_getFooter({})
            if (res.code == 200) {
                this.navGroups = res.data.navGroups && res.data.navGroups.length ? res.data.navGroups : this.navGroups
                this.settings = {
                    ...this.settings,
                    ...(res.data.settings || {}),
                }
                this.brandList = res.data.brandList || []
                this.footerLinks = res.data.footerLinks && res.data.footerLinks.length ? res.data.footerLinks : this.footerLinks
            } else {
                alertErr(res.msg)
            }
        },
        goFooterNav(item) {
            if (item.isBlank == 1 && item.linkValue) {
                window.open(item.linkValue, '_blank')
                return
            }
            if (item.linkType == 'article') {
                this.$router.push({
                    name: 'article',
                    params: {
                        name: item.linkValue,
                    },
                })
                return
            }
            if (item.linkType == 'page') {
                this.$router.push({
                    name: 'site-page',
                    params: {
                        pageKey: item.linkValue,
                    },
                })
                return
            }
            if (item.linkType == 'url') {
                window.open(item.linkValue, '_blank')
                return
            }
            if (item.linkValue) {
                this.$router.push({
                    path: item.linkValue,
                })
            }
        },
        goPageLink(item) {
            this.$router.push({
                name: 'site-page',
                params: {
                    pageKey: item.pageKey,
                },
            })
        },
        openSocial(url) {
            if (url) {
                window.open(url, '_blank')
            }
        },
        api_website_getFooter(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('website_getFooter', obj).then((res) => {
                    resolve(res)
                })
            })
        },
    },
}
</script>

<style lang="less" scoped>
.myPage92 {
    width: 100%;
    background: #f8f8fc;

    .myContent {
        padding: 35px 0;

        .bottomText1 {
            width: 100%;
            font-weight: bold;
            font-size: 12px;
            color: #000000;
            line-height: 24px;
            text-align: left;
        }

        .bottomText2 {
            font-weight: bold;
            font-size: 12px;
            color: #000000;
            line-height: 24px;
            text-align: left;
            margin-right: 8px;
        }

        .redText {
            font-weight: bold;
            font-size: 12px;
            color: #d61818;
            line-height: 24px;
            text-align: left;
            margin-right: 10px;
        }

        .bottomLogo {
            width: 84px;
            height: 34px;
            margin-right: 60px;
        }

        .myText {
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            line-height: 24px;
            text-align: left;
            margin-right: 60px;
        }

        .itemBox {
            width: 146px;

            .title {
                width: 100%;
                font-weight: bold;
                font-size: 16px;
                color: #000000;
                line-height: 24px;
                margin-bottom: 16px;
            }

            .text {
                width: 100%;
                font-weight: bold;
                font-size: 14px;
                color: #4ab284; // 改为绿色
                line-height: 24px;
                margin-bottom: 12px;
            }

            .iconBox {
                width: 100%;

                .icon {
                    cursor: pointer;
                    width: 32px;
                    height: 32px;
                    margin-right: 8px;
                    margin-bottom: 8px;
                }
            }
        }

        .greyLine {
            width: 2px;
            height: 230px;
            background: grey;
            opacity: 0.3;
        }

        .introBox {
            width: 325px;

            .title {
                width: 100%;
                font-weight: bold;
                font-size: 16px;
                color: #000000;
                line-height: 24px;
                text-align: left;
            }

            .title2 {
                width: 100%;
                font-weight: bold;
                font-size: 14px;
                color: #000000;
                line-height: 24px;
                text-align: left;
            }

            .text {
                width: 100%;
                font-weight: 400;
                font-size: 14px;
                color: #000000;
                line-height: 20px;
                text-align: left;
            }
        }
    }

    .hGreyLine {
        height: 2px;
        background: grey;
        opacity: 0.3;
        margin: 30px 0;
    }
}
</style>
<style lang="less" scoped src="./style/h5-page-foot.less"></style>
